import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

type CameraState = {
  hasCameraAccess: boolean | null
  cameraFacingMode: string
}

const initialState: CameraState = {
  hasCameraAccess: null,
  cameraFacingMode: 'environment',
}

export const cameraSlice = createSlice({
  name: 'camera',
  initialState,
  reducers: {
    setHasCameraAccess: (state, action: PayloadAction<boolean>) => {
      state.hasCameraAccess = action.payload
    },
    setCameraFacingMode: (state, action: PayloadAction<string>) => {
      state.cameraFacingMode = action.payload
    },
  }
})

export const {
  setHasCameraAccess,
  setCameraFacingMode,
} = cameraSlice.actions

export const getHasCameraAccessSelector = (state: RootState) => state.camera.hasCameraAccess
export const getCameraFacingModeSelector = (state: RootState) => state.camera.cameraFacingMode

export default cameraSlice.reducer
